
import React from "react";

const PostYourJob = () => {
  return (
    <div className="w-full max-w-4xl  p-6 bg-white min-h-screen">
      <h2 className="text-2xl font-bold mb-6 text-black">Post a Job</h2>

      <form className="space-y-6">
        {/* Job Title */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Job Title:</label>
          <input
            className="w-full border rounded px-4 py-2"
            placeholder="Enter job title"
          />
        </div>

        {/* Job Location */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Job Location:</label>
          <input
            className="w-full border rounded px-4 py-2"
            placeholder="Enter ZIP or city, state and select an option from the dropdown."
            defaultValue="Toronto, ON, Canada"
          />
        </div>

        {/* Street Address */}
        <div>
          <label className="block font-semibold text-sm mb-1">Street Address:</label>
          <p className="text-xs text-gray-600 mb-1">
            Some job boards allow users to search with a map. Enter your street address for better visibility.
          </p>
          <input
            className="w-full border rounded px-4 py-2"
            placeholder="123 Main Street"
          />
        </div>

        {/* Remote Work */}
        <div>
          <p className="block font-semibold text-sm mb-1">
            *Can this role be performed as a "remote work from home" job with no on-site work required?
          </p>
          <p className="text-xs text-gray-600 mb-2">
            Selecting Yes will allow this job post to be seen by local candidates and candidates looking for remote positions.
          </p>
          <div className="flex items-center gap-6">
            <label className="flex items-center gap-2">
              <input type="radio" name="remote" /> Yes
            </label>
            <label className="flex items-center gap-2">
              <input type="radio" name="remote" /> No
            </label>
          </div>
        </div>

        {/* Employment Type */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Employment Type:</label>
          <select className="w-full border rounded px-4 py-2">
            <option value="">- Select employment type -</option>
            <option>Full-time</option>
            <option>Part-time</option>
            <option>Contract</option>
          </select>
        </div>

        {/* Job Description */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Job Description:</label>
          <textarea
            rows={6}
            className="w-full border rounded px-4 py-2"
            placeholder="Enter job description"
          ></textarea>
        </div>

        {/* Benefits */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Benefits:</label>
          <input
            className="w-full border rounded px-4 py-2"
            placeholder="E.g. Dental, Medical, Vision"
          />
        </div>

        {/* Pay Information */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Pay Information:</label>
          <p className="text-xs text-gray-600 mb-2">
            Please include pay information or use the ZipRecruiter estimated pay. Job postings with pay information receive maximum visibility on ZipRecruiter!
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-2">
            <input
              className="border rounded px-4 py-2"
              placeholder="Min $"
              type="number"
            />
            <input
              className="border rounded px-4 py-2"
              placeholder="Max $"
              type="number"
            />
            <select className="border rounded px-4 py-2">
              <option>USD Annually</option>
              <option>USD Monthly</option>
              <option>USD Hourly</option>
            </select>
          </div>

          <label className="block mt-2 text-sm">
            <input type="checkbox" className="mr-2" /> Plus Commission
          </label>
        </div>

        {/* Hiring Company */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Hiring Company:</label>
          <input
            className="w-full border rounded px-4 py-2"
            defaultValue="clikkle"
          />
        </div>

        {/* Why Work Here */}
        <div>
          <label className="block font-semibold text-sm mb-1">Why Work at This Company?</label>
          <p className="text-xs text-gray-600 mb-1">
            Give a one-line sales pitch (140 characters max.). Affects all jobs at this company.
          </p>
          <input
            className="w-full border rounded px-4 py-2"
            defaultValue="Awesome CEO, great benefits, and lots of room for growth!"
          />
        </div>

        {/* Company Description */}
        <div>
          <label className="block font-semibold text-sm mb-1">Hiring Company Description:</label>
          <textarea
            rows={4}
            className="w-full border rounded px-4 py-2"
            placeholder="Describe your company"
          ></textarea>
        </div>

        {/* Skills */}
        <div>
          <label className="block font-semibold text-sm mb-1">Skills:</label>
          <input
            className="w-full border rounded px-4 py-2"
            placeholder="Enter a desired skill"
          />
        </div>

        {/* Send Candidates To */}
        <div>
          <label className="block font-semibold text-sm mb-1">*Send New Candidates To:</label>
          <p className="text-sm text-gray-700">S Graham (You!)</p>
          <label className="block mt-2 text-sm">
            <input type="checkbox" className="mr-2" /> Only show me candidates within 100 miles of this job's location
          </label>
          <label className="block mt-2 text-sm">
            <input type="checkbox" className="mr-2" /> Accept applications without a resume or profile
          </label>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 mt-8">
          <button className="bg-black text-white px-6 py-2 rounded font-semibold hover:bg-black">
            Save & Post Now
          </button>
          <button className="border border-gray-400 text-gray-800 px-6 py-2 rounded font-semibold hover:bg-gray-100">
            Save Draft
          </button>
        </div>
      </form>
    </div>
  );
};

export default PostYourJob;

